/**
 * SWIST Wishlist
 * localStorage anahtarı: misafir → "wl_guest", üye → "wl_<customerId>"
 * Depolama formatı: [{id: "123456789", handle: "urun-adi"}, ...]
 */
(function () {
  'use strict';

  /* ─── Çift yüklenme koruması ──────────────────────────────── */
  if (window.__swistWishlistLoaded) return;
  window.__swistWishlistLoaded = true;

  var STORAGE_PREFIX = 'wl_';
  var GUEST_KEY      = 'wl_guest';
  var EVENT_NAME     = 'wishlist:change';

  /* ─── localStorage'dan oku ────────────────────────────────── */
  function readItems(key) {
    try {
      var raw    = localStorage.getItem(key);
      var parsed = JSON.parse(raw || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.map(function (item) {
        return (typeof item === 'string') ? { id: item, handle: '' } : item;
      });
    } catch (e) {
      return [];
    }
  }

  /* ─── localStorage'a yaz ──────────────────────────────────── */
  function writeItems(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) { /* sessiz */ }
  }

  /* ─── Depolama anahtarını belirle ─────────────────────────── */
  var customerId = window.__swistCustomerId || null;
  var storageKey = customerId ? (STORAGE_PREFIX + customerId) : GUEST_KEY;

  /* ─── Misafir listesini üyeye aktar ───────────────────────── */
  if (customerId) {
    try {
      var guestItems  = readItems(GUEST_KEY);
      var memberItems = readItems(storageKey);
      if (guestItems.length) {
        var merged = guestItems.concat(memberItems).reduce(function (acc, item) {
          if (!acc.some(function (i) { return i.id === item.id; })) acc.push(item);
          return acc;
        }, []);
        writeItems(storageKey, merged);
        localStorage.removeItem(GUEST_KEY);
      }
    } catch (e) { /* sessiz */ }
  }

  /* ─── Değişiklik eventi ───────────────────────────────────── */
  function emitChange(items) {
    var ids = items.map(function (i) { return i.id; });
    document.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: { items: items, ids: ids, count: items.length }
    }));
  }

  /* ─── Public API ──────────────────────────────────────────── */
  var Wishlist = {
    getItems:  function () { return readItems(storageKey); },
    getIds:    function () { return readItems(storageKey).map(function (i) { return i.id; }); },
    has: function (productId) {
      var id = String(productId);
      return readItems(storageKey).some(function (i) { return i.id === id; });
    },
    add: function (productId, productHandle) {
      var id    = String(productId);
      var items = readItems(storageKey);
      if (!items.some(function (i) { return i.id === id; })) {
        items.unshift({ id: id, handle: productHandle || '' });
        writeItems(storageKey, items);
        emitChange(items);
      }
    },
    remove: function (productId) {
      var id    = String(productId);
      var items = readItems(storageKey).filter(function (i) { return i.id !== id; });
      writeItems(storageKey, items);
      emitChange(items);
    },
    toggle: function (productId, productHandle) {
      this.has(productId) ? this.remove(productId) : this.add(productId, productHandle);
    },
    count: function () { return readItems(storageKey).length; }
  };

  window.swistWishlist = Wishlist;

  /* ─── UI: buton görünümünü güncelle ───────────────────────── */
  function updateButtons(ids) {
    document.querySelectorAll('[data-wl-btn]').forEach(function (btn) {
      var isActive = ids.indexOf(String(btn.dataset.wlBtn)) !== -1;
      btn.classList.toggle('wl-btn--active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
      btn.title = isActive ? 'Favorilerden çıkar' : 'Favorilere ekle';
      var icon = btn.querySelector('.wl-icon');
      if (icon) {
        if (isActive) {
          icon.setAttribute('fill', 'currentColor');
          icon.setAttribute('stroke-width', '0');
        } else {
          icon.setAttribute('fill', 'none');
          icon.setAttribute('stroke-width', '1.8');
        }
      }
    });
  }

  /* ─── UI: sayaçları güncelle ──────────────────────────────── */
  function updateCounters(count) {
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden      = count === 0;
    });
    document.querySelectorAll('[data-wl-count-wrap]').forEach(function (el) {
      el.hidden = count === 0;
    });
  }

  /* ─── wishlist:change eventini dinle ──────────────────────── */
  document.addEventListener(EVENT_NAME, function (e) {
    updateButtons(e.detail.ids);
    updateCounters(e.detail.count);
  });

  /* ─── Delegated click handler ─────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-btn]');
    if (!btn) return;
    e.preventDefault();
    Wishlist.toggle(btn.dataset.wlBtn, btn.dataset.wlHandle || '');
  });

  /* ─── Sayfa yüklenince ilk güncelleme ─────────────────────── */
  function onReady() {
    var ids = Wishlist.getIds();
    updateButtons(ids);
    updateCounters(ids.length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }


  /* ═══════════════════════════════════════════════════════════
     QUICK-ADD MODAL  (Horizon teması uyumlu)
     ═══════════════════════════════════════════════════════════ */

  /* ─── Horizon cart:update eventini ateşle ─────────────────── */
  /* Sepete ürün eklendikten sonra Horizon'ın cart-drawer-component
     bileşenine bildirim gönderir → drawer açılır ve adet güncellenir. */
  function triggerHorizonCartUpdate(addedCount) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            itemCount: addedCount || 1,
            source:    'product-form-component'   // Horizon'ın beklediği kaynak
          }
        }
      })
    );
  }

  /* ─── /cart/add.js ile sepete ekle ───────────────────────── */
  function addToCart(variantId, quantity, btnEl, onSuccess, onError) {
    if (btnEl) { btnEl.disabled = true; btnEl.textContent = 'Ekleniyor…'; }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart_error');
      return r.json();
    })
    .then(function (data) {
      triggerHorizonCartUpdate(data.quantity);
      if (typeof onSuccess === 'function') onSuccess(data);
    })
    .catch(function (err) {
      if (typeof onError === 'function') onError(err);
    });
  }

  /* ─── Modal HTML + CSS oluştur (bir kez) ─────────────────── */
  function ensureModalShell() {
    if (document.getElementById('wl-qa-overlay')) return;

    /* ── CSS ── */
    var style = document.createElement('style');
    style.textContent = [
      '#wl-qa-overlay{',
        'position:fixed;inset:0;z-index:99999;',
        'display:flex;align-items:center;justify-content:center;',
        'background:rgba(0,0,0,.45);',
        'opacity:0;visibility:hidden;',
        'transition:opacity .25s,visibility .25s;',
      '}',
      '#wl-qa-overlay.wl-qa--open{opacity:1;visibility:visible;}',
      '#wl-qa-modal{',
        'background:#fff;border-radius:12px;',
        'padding:28px 24px 24px;',
        'width:min(420px,92vw);max-height:90vh;overflow-y:auto;',
        'position:relative;',
        'transform:translateY(16px);',
        'transition:transform .25s;',
        'font-family:inherit;',
      '}',
      '#wl-qa-overlay.wl-qa--open #wl-qa-modal{transform:translateY(0);}',
      '#wl-qa-close{',
        'position:absolute;top:12px;right:14px;',
        'background:none;border:none;cursor:pointer;',
        'font-size:22px;line-height:1;color:#555;padding:4px 6px;',
      '}',
      '#wl-qa-close:hover{color:#000;}',
      '.wl-qa__img{width:100%;max-height:220px;object-fit:contain;margin-bottom:14px;border-radius:8px;}',
      '.wl-qa__title{font-size:1rem;font-weight:600;margin:0 0 4px;}',
      '.wl-qa__price{font-size:.95rem;color:#555;margin:0 0 16px;}',
      '.wl-qa__label{display:block;font-size:.82rem;font-weight:600;margin-bottom:6px;text-transform:uppercase;letter-spacing:.04em;}',
      '.wl-qa__select{',
        'width:100%;padding:9px 12px;',
        'border:1px solid #ccc;border-radius:6px;',
        'font-size:.9rem;background:#fff;cursor:pointer;',
        'margin-bottom:14px;appearance:none;',
        'background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23333\' stroke-width=\'2\'%3E%3Cpolyline points=\'6 9 12 15 18 9\'/%3E%3C/svg%3E");',
        'background-repeat:no-repeat;background-position:right 10px center;background-size:16px;',
        'padding-right:34px;',
      '}',
      '.wl-qa__select:focus{outline:none;border-color:#000;}',
      '.wl-qa__unavail{font-size:.82rem;color:#c00;margin:-8px 0 12px;display:none;}',
      '.wl-qa__atc{',
        'width:100%;padding:13px;',
        'background:#000;color:#fff;',
        'border:none;border-radius:8px;',
        'font-size:.95rem;font-weight:600;cursor:pointer;',
        'transition:background .2s,opacity .2s;',
      '}',
      '.wl-qa__atc:hover:not(:disabled){background:#222;}',
      '.wl-qa__atc:disabled{opacity:.5;cursor:not-allowed;}',
      '.wl-qa__atc--success{background:#2a7a2a;}',
      '.wl-qa__qty-wrap{display:flex;align-items:center;gap:8px;margin-bottom:14px;}',
      '.wl-qa__qty-wrap label{font-size:.82rem;font-weight:600;text-transform:uppercase;letter-spacing:.04em;white-space:nowrap;}',
      '.wl-qa__qty{width:70px;padding:8px 10px;border:1px solid #ccc;border-radius:6px;font-size:.9rem;text-align:center;}',
      '.wl-qa__qty:focus{outline:none;border-color:#000;}',
    ].join('');
    document.head.appendChild(style);

    /* ── HTML ── */
    var overlay = document.createElement('div');
    overlay.id = 'wl-qa-overlay';
    overlay.innerHTML = '<div id="wl-qa-modal"><button id="wl-qa-close" aria-label="Kapat">&times;</button><div id="wl-qa-content"></div></div>';
    document.body.appendChild(overlay);

    /* Kapat: overlay tıklaması veya X butonu */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQAModal();
    });
    document.getElementById('wl-qa-close').addEventListener('click', closeQAModal);

    /* ESC tuşu */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQAModal();
    });
  }

  function openQAModal()  {
    var el = document.getElementById('wl-qa-overlay');
    if (el) { el.classList.add('wl-qa--open'); document.body.style.overflow = 'hidden'; }
  }

  function closeQAModal() {
    var el = document.getElementById('wl-qa-overlay');
    if (el) { el.classList.remove('wl-qa--open'); document.body.style.overflow = ''; }
  }

  /* ─── Para birimi formatı ─────────────────────────────────── */
  function getFmt() {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'TRY';
    return function (cents) {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency }).format(cents / 100);
    };
  }

  /* ─── Güvenli görsel URL çıkarıcı ────────────────────────────
     Shopify bazı endpoint'lerde featured_image'ı string dönerken
     bazılarında { src: "..." } objesi olarak döner. Her ikisini de
     handle ediyoruz. Obje gelirse → .src al, string gelirse → direkt
     kullan, boş / null / undefined → '' döner.
     ────────────────────────────────────────────────────────────── */
  function getImgSrc(val) {
    if (!val) return '';
    if (typeof val === 'string') return val;
    if (typeof val === 'object' && val.src) return val.src;
    return '';
  }

  /* ─── Modal CSS'ine karşılaştırmalı fiyat satırı ekle ─────── */
  /* (ensureModalShell içindeki style bloğuna ek kural)           */
  var _qaExtraStyleAdded = false;
  function addQACompareStyle() {
    if (_qaExtraStyleAdded) return;
    _qaExtraStyleAdded = true;
    var s = document.createElement('style');
    s.textContent =
      '.wl-qa__prices{display:flex;align-items:baseline;gap:8px;margin:0 0 16px;}' +
      '.wl-qa__price-current{font-size:.95rem;font-weight:700;color:#000;}' +
      '.wl-qa__price-compare{font-size:.85rem;color:#999;text-decoration:line-through;}' +
      '.wl-qa__badge{display:inline-block;font-size:.75rem;font-weight:700;' +
        'background:#e00;color:#fff;border-radius:4px;padding:2px 6px;}';
    document.head.appendChild(s);
  }

  /* ─── Çok varyantlı ürün için modal içeriğini doldur ─────── */
  function buildQAModal(product) {
    ensureModalShell();
    addQACompareStyle();

    var fmt      = getFmt();
    var options  = product.options  || [];
    var variants = product.variants || [];

    /* featured_image → güvenli string URL */
    var baseImgSrc = getImgSrc(product.featured_image);

    /* ── Modal içeriği sıfırla ── */
    var content = document.getElementById('wl-qa-content');
    content.innerHTML = '';

    /* ── Ürün görseli ── */
    var imgEl = null;
    if (baseImgSrc) {
      imgEl = document.createElement('img');
      imgEl.src       = baseImgSrc;
      imgEl.alt       = String(product.title || '');
      imgEl.className = 'wl-qa__img';
      content.appendChild(imgEl);
    }

    /* ── Başlık ── */
    var titleEl = document.createElement('p');
    titleEl.className   = 'wl-qa__title';
    titleEl.textContent = String(product.title || '');
    content.appendChild(titleEl);

    /* ── Fiyat satırı (güncel + üstü çizili) ── */
    var pricesWrap = document.createElement('div');
    pricesWrap.className = 'wl-qa__prices';

    var priceEl   = document.createElement('span');
    priceEl.className   = 'wl-qa__price-current';

    var compareEl = document.createElement('span');
    compareEl.className = 'wl-qa__price-compare';

    var badgeEl   = document.createElement('span');
    badgeEl.className   = 'wl-qa__badge';

    pricesWrap.appendChild(priceEl);
    pricesWrap.appendChild(compareEl);
    pricesWrap.appendChild(badgeEl);
    content.appendChild(pricesWrap);

    /* ── Option select'leri ── */
    var selects      = [];
    var optFallbacks = ['Renk', 'Beden', 'Boyut', 'Materyal'];

    options.forEach(function (optName, i) {
      /* <div> kullan — temalar label { display:none } uygulayabilir */
      var labelDiv = document.createElement('div');
      labelDiv.style.cssText =
        'display:block!important;font-size:.82rem;font-weight:600;' +
        'margin-bottom:6px;text-transform:uppercase;letter-spacing:.04em;' +
        'color:inherit;';
      /* optName string mi kontrol et — obje gelirse fallback kullan */
      labelDiv.textContent =
        (typeof optName === 'string' && optName) ? optName
        : (optFallbacks[i] || ('Seçenek ' + (i + 1)));
      content.appendChild(labelDiv);

      var sel = document.createElement('select');
      sel.className        = 'wl-qa__select';
      sel.dataset.optIndex = String(i);

      /* O option'a ait benzersiz değerleri sırayla topla */
      var seen   = {};
      var values = [];
      variants.forEach(function (v) {
        var raw = v['option' + (i + 1)];
        /* Obje gelebilir mi? Hayır ama yine de string'e cast et */
        var val = (raw !== null && raw !== undefined) ? String(raw) : '';
        if (val && !seen[val]) { seen[val] = 1; values.push(val); }
      });

      values.forEach(function (val) {
        var opt       = document.createElement('option');
        opt.value     = val;
        opt.textContent = val;
        sel.appendChild(opt);
      });

      content.appendChild(sel);
      selects.push(sel);
    });

    /* ── Stok uyarısı ── */
    var unavailEl         = document.createElement('p');
    unavailEl.className   = 'wl-qa__unavail';
    unavailEl.textContent = 'Bu kombinasyon stokta yok.';
    unavailEl.style.display = 'none';
    content.appendChild(unavailEl);

    /* ── Adet ── */
    var qtyWrap = document.createElement('div');
    qtyWrap.className   = 'wl-qa__qty-wrap';
    qtyWrap.innerHTML   =
      '<label for="wl-qa-qty" style="font-size:.82rem;font-weight:600;' +
        'text-transform:uppercase;letter-spacing:.04em;white-space:nowrap;">' +
        'Adet</label>' +
      '<input id="wl-qa-qty" class="wl-qa__qty" type="number" min="1" value="1">';
    content.appendChild(qtyWrap);

    /* ── Sepete Ekle butonu ── */
    var atcBtn          = document.createElement('button');
    atcBtn.type         = 'button';
    atcBtn.className    = 'wl-qa__atc';
    atcBtn.textContent  = 'Sepete Ekle';
    content.appendChild(atcBtn);

    /* ── Seçili varyantı bul ── */
    function getSelectedVariant() {
      return variants.find(function (v) {
        return selects.every(function (sel, i) {
          return String(v['option' + (i + 1)]) === sel.value;
        });
      }) || null;
    }

    /* ── Fiyat satırını güncelle ── */
    function updatePrices(variant) {
      var price   = variant ? Number(variant.price)           : Number(product.price || 0);
      var compare = variant ? Number(variant.compare_at_price || 0)
                            : Number(product.compare_at_price || 0);

      priceEl.textContent = fmt(price);

      if (compare > price) {
        var disc = Math.round((compare - price) / compare * 100);
        compareEl.textContent = fmt(compare);
        compareEl.style.display = '';
        badgeEl.textContent     = '-%' + disc;
        badgeEl.style.display   = '';
      } else {
        compareEl.textContent   = '';
        compareEl.style.display = 'none';
        badgeEl.textContent     = '';
        badgeEl.style.display   = 'none';
      }
    }

    /* ── Select değişince UI'ı güncelle ── */
    function onSelectChange() {
      var variant   = getSelectedVariant();
      var available = !!(variant && variant.available);

      /* Stok uyarısı */
      unavailEl.style.display = (!variant || !available) ? 'block' : 'none';

      /* Buton durumu */
      atcBtn.disabled     = !available;
      atcBtn.textContent  = available      ? 'Sepete Ekle'
                          : (variant       ? 'Stokta Yok'
                                           : 'Mevcut Değil');

      /* Fiyat güncelle */
      updatePrices(variant);

      /* Görsel güncelle — varyanta özel görsel varsa değiştir */
      if (imgEl) {
        var varImgSrc = variant ? getImgSrc(variant.featured_image) : '';
        imgEl.src = varImgSrc || baseImgSrc;
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', onSelectChange);
    });
    onSelectChange(); /* ilk render */

    /* ── Sepete Ekle tıklanması ── */
    atcBtn.addEventListener('click', function () {
      var variant = getSelectedVariant();
      if (!variant || !variant.available) return;
      var qty = parseInt(document.getElementById('wl-qa-qty').value, 10) || 1;
      addToCart(variant.id, qty, atcBtn,
        function () {
          atcBtn.textContent = '✓ Eklendi!';
          atcBtn.classList.add('wl-qa__atc--success');
          setTimeout(function () {
            closeQAModal();
            atcBtn.textContent = 'Sepete Ekle';
            atcBtn.classList.remove('wl-qa__atc--success');
            atcBtn.disabled = false;
          }, 1200);
        },
        function () {
          atcBtn.textContent = 'Hata oluştu, tekrar dene';
          atcBtn.disabled = false;
        }
      );
    });

    openQAModal();
  }

  /* ─── Tek varyantlı ürünler için inline Sepete Ekle ──────── */
  function handleSingleVariantATC(btn, variantId) {
    var card = btn.closest('.wl-card');
    addToCart(variantId, 1, btn,
      function () {
        btn.textContent = '✓ Eklendi!';
        btn.style.background = '#2a7a2a';
        setTimeout(function () {
          btn.textContent = 'Sepete Ekle';
          btn.style.background = '';
          btn.disabled = false;
        }, 1500);
      },
      function () {
        btn.textContent = 'Hata, tekrar dene';
        btn.disabled = false;
      }
    );
  }


  /* ═══════════════════════════════════════════════════════════
     Wishlist Sayfası — ürünleri /products/{handle}.js ile yükle
     ═══════════════════════════════════════════════════════════ */
  window.swistLoadWishlistProducts = function (container) {
    var emptyEl = container.querySelector('[data-wl-empty]');
    var loadEl  = container.querySelector('[data-wl-loading]');
    var grid    = container.querySelector('[data-wl-grid]');

    var items     = Wishlist.getItems();
    var fetchable = items.filter(function (i) { return !!i.handle; });

    /* Handle'sız eski kayıtları temizle */
    if (items.length && !fetchable.length) {
      writeItems(storageKey, []);
      emitChange([]);
    }

    if (!fetchable.length) {
      if (emptyEl) emptyEl.hidden = false;
      if (loadEl)  loadEl.hidden  = true;
      if (grid)    grid.hidden    = true;
      return Promise.resolve();
    }

    if (loadEl) loadEl.hidden = false;

    var rootUrl  = (window.__swistRootUrl || '').replace(/\/$/, '');
    var requests = fetchable.map(function (item) {
      return fetch(rootUrl + '/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });

    return Promise.all(requests).then(function (results) {
      if (loadEl) loadEl.hidden = true;

      var products = results
        .map(function (data, i) {
          if (!data) return null;
          data._localId = fetchable[i].id;
          return data;
        })
        .filter(Boolean);

      if (!products.length) {
        if (emptyEl) emptyEl.hidden = false;
        if (grid)    grid.hidden    = true;
        return;
      }

      if (!grid) return;
      grid.innerHTML = '';
      grid.hidden    = false;
      if (emptyEl) emptyEl.hidden = true;

      var fmt = getFmt();

      products.forEach(function (p) {
        var id           = p._localId;
        var price        = Number(p.price || 0);
        var compare      = Number(p.compare_at_price || 0);
        var disc         = (compare > price) ? Math.round((compare - price) / compare * 100) : 0;
        var img          = getImgSrc(p.featured_image);   /* string veya obje → güvenli URL */
        var variants     = p.variants || [];
        var isSingle     = variants.length === 1;
        var singleVarId  = isSingle ? variants[0].id : null;
        var available    = p.available;

        /* ─── ATC butonu metni & data ───────────────────────── */
        /*
          Tek varyant   → "Sepete Ekle"  (data-wl-single-atc)
          Çok varyant   → "Seçenekleri Gör" (data-wl-multi-atc → modal)
          Stokta yok    → "Stokta Yok"   (disabled)
        */
        var atcBtnHtml;
        if (!available) {
          atcBtnHtml =
            '<button class="wl-card__atc-btn" disabled>' +
              'Stokta Yok' +
            '</button>';
        } else if (isSingle) {
          atcBtnHtml =
            '<button class="wl-card__atc-btn"' +
              ' data-wl-single-atc="' + singleVarId + '"' +
              ' type="button">' +
              'Sepete Ekle' +
            '</button>';
        } else {
          /* Çok varyantlı: ürün verisini JSON olarak sakla.
             Güvenli geçiş için base64 encode edilir (HTML attribute içinde
             JSON'da çift tırnak çakışmasını önler).                        */
          var encoded = btoa(unescape(encodeURIComponent(JSON.stringify({
            id:             p.id,
            title:          String(p.title || ''),
            handle:         p.handle,
            featured_image: getImgSrc(p.featured_image),  /* her zaman string */
            price:          Number(p.price || 0),
            compare_at_price: Number(p.compare_at_price || 0),
            options:        p.options,
            variants:       p.variants
          }))));
          atcBtnHtml =
            '<button class="wl-card__atc-btn wl-card__atc-btn--options"' +
              ' data-wl-multi-atc="' + encoded + '"' +
              ' type="button">' +
              'Sepete Ekle' +
            '</button>';
        }

        var card = document.createElement('div');
        card.className = 'wl-card';
        card.innerHTML =
          '<a href="/products/' + p.handle + '" class="wl-card__img-wrap">' +
            (img
              ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="300" height="400">'
              : '<div class="wl-card__no-img"></div>') +
            (disc > 0 ? '<span class="wl-card__badge">-%' + disc + '</span>' : '') +
          '</a>' +
          '<div class="wl-card__body">' +
            '<a href="/products/' + p.handle + '" class="wl-card__title">' + escapeHtml(p.title) + '</a>' +
            '<div class="wl-card__prices">' +
              '<span class="wl-card__price">' + fmt(price) + '</span>' +
              (compare > price ? '<span class="wl-card__compare">' + fmt(compare) + '</span>' : '') +
            '</div>' +
            '<div class="wl-card__actions">' +
              atcBtnHtml +
              '<button' +
                ' class="wl-card__remove"' +
                ' data-wl-btn="' + id + '"' +
                ' data-wl-handle="' + p.handle + '"' +
                ' aria-pressed="true"' +
                ' title="Favorilerden çıkar"' +
                ' type="button"' +
              '>' +
                '<svg width="18" height="18" viewBox="0 0 24 24"' +
                  ' fill="currentColor" stroke-width="0" class="wl-icon">' +
                  '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06' +
                    'a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 ' +
                    '1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
          '</div>';

        grid.appendChild(card);
      });

      /* ─── Delegated click → ATC & kart kaldırma ───────────── */
      grid.addEventListener('click', function (e) {

        /* Favori kaldır (animasyonlu) */
        var removeBtn = e.target.closest('.wl-card__remove');
        if (removeBtn) {
          var card = removeBtn.closest('.wl-card');
          if (!card) return;
          card.style.transition = 'opacity .25s, transform .25s';
          card.style.opacity    = '0';
          card.style.transform  = 'scale(0.95)';
          setTimeout(function () {
            card.remove();
            if (!grid.querySelectorAll('.wl-card').length) {
              grid.hidden = true;
              if (emptyEl) emptyEl.hidden = false;
            }
          }, 260);
          return;
        }

        /* Tek varyantlı → Sepete Ekle */
        var singleBtn = e.target.closest('[data-wl-single-atc]');
        if (singleBtn) {
          handleSingleVariantATC(singleBtn, singleBtn.dataset.wlSingleAtc);
          return;
        }

        /* Çok varyantlı → Quick-Add Modal'ı aç */
        var multiBtn = e.target.closest('[data-wl-multi-atc]');
        if (multiBtn) {
          try {
            var productData = JSON.parse(
              decodeURIComponent(escape(atob(multiBtn.dataset.wlMultiAtc)))
            );
            buildQAModal(productData);
          } catch (err) {
            console.error('[SWIST] modal parse error', err);
          }
        }
      });
    });
  };

  /* ─── XSS önlemi ──────────────────────────────────────────── */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─── writeItems ve storageKey'i dışa aç ─────────────────── */
  window.__swistWishlistWrite = writeItems;
  window.__swistWishlistKey   = storageKey;

})();